import { cssModules } from '@skyscanner-internal/backpack-web/bpk-react-utils';

import STYLES from './DotMarker.module.scss';

const cls = cssModules(STYLES);

const DotMarker = () => (
  <>
    <div className={cls('DotMarker--cluster', 'DotMarker--initial')} />
    <div className={STYLES.DotMarker__markerButton} />
  </>
);

export default DotMarker;
